import axios from 'axios';
import moment from 'moment';

export default async function syncReadingsSavedOffline(db, editingReading) {
  await db.get(`readingsSavedOffline`)
    .then(async doc => {
      //console.log("readings to be saved length", doc.readings.length);
      let docToSync = doc.readings.filter(a => a.isSync == false);
      for (let i = 0; i < docToSync.length; i++) {
        const reading = doc.readings[i].reading;
        const parameter = {
          BookId: reading.bookId,
          WalkId: reading.walkId,
          Sequence: reading.sequence,

          CrReading: reading.crReading,
          ClockOver: reading.clockOver,
          CrDateTime: moment(reading.crDate).format('YYYY-MM-DDTHH:mm:ss'),

          AccessCodeId: reading.accessCodeId,
          MrMsgCodeId: reading.mrMsgCodeId,
          SerialNo: reading.serialNo,
          MeterMakeId: reading.meterMakeId,
          MeterSizeId: reading.meterSizeId,
          NoDials: reading.noDials,
          CellTelNo: reading.cellTelNo,
          ConsumerTypeId: reading.consumerTypeId,
          Comment: reading.comment,
          FieldStatus: reading.fieldStatus
        };

        if (reading.specialCase) {
          parameter['Consumption'] = reading.averageConsumption;
        }

        await axios.post('/CaptureMeterReading/UpdateReadingDetails', parameter)
          .then(res => {
            if (res.status == 200 && !res.data.data) {
              doc.readings[i].isSync = true;
              editingReading.isEdited = false;
            }
            else {
              editingReading.isEdited = true;
            }

            editingReading.status = res.status;
          })
          .catch(err => { editingReading.isEdited = false; })
      }

      if (doc.readings.filter(a => a.isSync == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch(err => {
      //console.log("error readingsSavedOffline", err);
    }
    );

  await db.get(`readingsPhotosSavedOffline`)
    .then(async doc => {
      let docToSync = doc.photos.filter(a => a.isSync == false);

      for (let i = 0; i < docToSync.length; i++) {
        //console.log("record to save", i, ' - ', docToSync[i])
        var formData = new FormData();
        formData.append("meterId", docToSync[i].meterId);
        formData.append("cycleId", docToSync[i].cycleId);
        formData.append("connectionId", docToSync[i].connectionId);
        formData.append("photoBase64", docToSync[i].photoBase64);

        await axios.post('/CaptureMeterReading/ProcessPhoto', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            if (response.status == 200 && response.data.data.status == 0) {
            doc.photos[i].isSync = true;
          }
          else
            doc.photos[i].isSync = false;
        })
          .catch(e => {
            doc.photos[i].isSync = false;
          });
      }

      if (doc.photos.filter(a => a.isSync == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch(err => {
      //console.log("readingsPhotosSavedOffline", err);
    });


  await db.get(`readingsSmsRequestsSavedOffline`)
    .then(async doc => {
      //console.log("readingsSmsRequestsSavedOffline", doc.requests);
      let docToSync = doc.requests.filter(a => a.isSync == false);

      for (let i = 0; i < docToSync.length; i++) {
        if (docToSync[i].isSync == false) {
          let param = { ...docToSync[i].parameter };

          if (param.meterRef)
            delete param.meterRef;

          if (param.address)
            delete param.address;

          await axios.post('/CaptureMeterReading/SendSms', param)
            .then(response => {
              if (response.data.data.status == 0 ||
                (response.data.data.status == 1 && response.data.data.text == "Account doesn't have Cell Tel No specified")) {
                doc.requests[i].isSync = true;
              }
              else
                doc.requests[i].isSync = false;
            })
            .catch(e => {
              //console.log("sendsms error", e);
              doc.requests[i].isSync = false;
              return false;
            })
        }
      }
      
      if (doc.requests.filter(a => a.isSync == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {});
      }
    })
    .catch(err => {
     // console.log("error readingsSmsRequestsSavedOffline", err);
    }
    );
}
